import React, { useState, useEffect } from 'react';
import {
  CollectionIcon,
  LibraryIcon,
  BriefcaseIcon,
  PlusCircleIcon,
  ArrowCircleLeftIcon,
  TruckIcon,
  PencilAltIcon,
  XCircleIcon,
  CheckCircleIcon,
  ArrowCircleUpIcon,
  ArrowCircleDownIcon,
  ArrowUpIcon,
} from '@heroicons/react/outline';
import Popup from '../Low Level/Popup';
import Switch from '@material-ui/core/Switch';
import CitizenUserDropboxMenu from '../Low Level/CitizenUserDropboxMenu';
import NewTransferPopupBody from '../Low Level/NewTransferPopupBody';
import NewBusinessTransferPopupBody from '../Low Level/NewBusinessTransferPopupBody';
import PurchaseSuccessfulPopupBody from '../Low Level/PurchaseSuccessfulPopupBody';

const Business = ({ database, user, setUser, getTime, getDate, getYear }) => {
  const [selectedBusiness, setSelectedBusiness] = useState(
    JSON.parse(localStorage.getItem('selectedBusiness')),
  );
  const [selectedSection, setSelectedSection] = useState('Items');
  const [addItemPopupOpen, setAddItemPopupOpen] = useState(false);
  const [editItemPopupOpen, setEditItemPopupOpen] = useState(false);
  const [productBeingEdited, setProductBeingEdited] = useState();
  const [citizens, setCitizens] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [filteredCitizens, setFilteredCitizens] = useState([]);
  const [transferDropboxCitizens, setTransferDropboxCitizens] = useState([]);
  const [filteredTransferDropboxCitizens, setFilteredTransferDropboxCitizens] =
    useState([]);
  const [selectedCitizen, setSelectedCitizen] = useState();
  const [newTransferPopupOpen, setNewTransferPopupOpen] = useState(false);
  const [newBusinessName, setNewBusinessName] = useState(
    JSON.parse(localStorage.getItem('selectedBusiness')).name,
  );
  const [newBusinessDescription, setNewBusinessDescription] = useState(
    JSON.parse(localStorage.getItem('selectedBusiness')).description,
  );
  const [salesTaxRate, setSalesTaxRate] = useState(0);
  const [purchaseSuccessfulPopupBodyOpen, setPurchaseSuccessfulPopupBodyOpen] =
    useState(false);

  const charlingtonEpoch = 1766275200000;

  useEffect(updateCitizens, []);

  function updateCitizens() {
    database
      .ref('/citizens')
      .get()
      .then((citizensObjects) => {
        const citizens = Object.values(citizensObjects.val()).filter(
          (citizen) => {
            var citizenIsNotInList = true;
            Object.values(selectedBusiness.owners).forEach((owner) => {
              if (owner.citizenID == citizen.citizenID)
                citizenIsNotInList = false;
            });
            return citizenIsNotInList;
          },
        );
        setCitizens(citizens);
        setFilteredCitizens(citizens);
        database
          .ref('/government/salesTaxRate')
          .get()
          .then((salesTaxRateSnapshot) => {
            setSalesTaxRate(salesTaxRateSnapshot.val());
          });
      });
  }

  const navigationSections =
    selectedBusiness.founder.citizenID == user.citizenID
      ? [
          {
            sectionName: 'Items',
            sectionSelected: selectedSection == 'Items',
            icon: CollectionIcon,
          },
          {
            sectionName: 'Bank Account',
            sectionSelected: selectedSection == 'Bank Account',
            icon: LibraryIcon,
          },
          {
            sectionName: 'Orders',
            sectionSelected: selectedSection == 'Orders',
            icon: TruckIcon,
          },
          {
            sectionName: 'Manage',
            sectionSelected: selectedSection == 'Manage',
            icon: BriefcaseIcon,
          },
        ]
      : [
          {
            sectionName: 'Items',
            sectionSelected: selectedSection == 'Items',
            icon: CollectionIcon,
          },
          {
            sectionName: 'Bank Account',
            sectionSelected: selectedSection == 'Bank Account',
            icon: LibraryIcon,
          },
          {
            sectionName: 'Orders',
            sectionSelected: selectedSection == 'Orders',
            icon: TruckIcon,
          },
        ];

  const userIsOwner = checkUserIsOwner();

  function checkUserIsOwner() {
    var userIsOwner = false;
    Object.values(selectedBusiness.owners).forEach((owner) => {
      if (owner.citizenID == user.citizenID) userIsOwner = true;
    });
    return userIsOwner;
  }

  console.log('userIsOwner', userIsOwner);

  useEffect(updateBusiness, []);

  function updateBusiness() {
    database
      .ref(`/businesses/${selectedBusiness.businessID}`)
      .get()
      .then((businessSnapshot) => {
        const business = businessSnapshot.val();

        let newShareValueIfBought = business.westers / getSharesOwned(business);
        //let newPriceIfBought = business.stockHistory[business.stockHistory.length - 1].price;
        newShareValueIfBought =
          newShareValueIfBought + newShareValueIfBought * 0.05;
        let newSharesOwnedIfBought = getSharesOwned(business) + 1;

        let newBusinessBalanceIfBought =
          newShareValueIfBought * newSharesOwnedIfBought;

        // Make up the difference
        const newPriceIfBought = newBusinessBalanceIfBought - business.westers;

        if (
          business.stockHistory[business.stockHistory.length - 1].price.toFixed(
            2,
          ) != newPriceIfBought.toFixed(2)
        ) {
          business.stockHistory = [
            ...business.stockHistory,
            {
              time: Date.now(),
              price: newPriceIfBought,
              citizenID: 'SYSTEM',
              citizenName: 'SYSTEM',
              bought: false,
            },
          ];
        }

        database
          .ref(`/businesses/${selectedBusiness.businessID}/stockHistory`)
          .set(business.stockHistory);

        setSelectedBusiness(business);
        localStorage.setItem('selectedBusiness', JSON.stringify(business));
      });
  }

  function censor(id) {
    return id.startsWith('CI-') && user.citizenID != id
      ? `CI-***${id.substring(6, 8)}`
      : id;
  }

  function generateID(prefix) {
    var transferID = `${prefix}-`;
    for (var i = 0; i < 5; i++) {
      transferID = transferID + String(Math.floor(Math.random() * 10));
    }
    return transferID;
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  const totalSharesOwned = selectedBusiness.stockHistory.filter(
    (stockTransfer) => {
      return (
        stockTransfer.bought == true && stockTransfer.citizenID != 'SYSTEM'
      );
    },
  ).length;

  let uniqueCitizens = new Map();

  selectedBusiness.stockHistory.forEach((stockTransfer) => {
    if (stockTransfer.citizenID != 'SYSTEM')
      if (stockTransfer.bought == true)
        uniqueCitizens.set(stockTransfer.citizenID, {
          citizenID: stockTransfer.citizenID,
          citizenName: stockTransfer.citizenName,
        });
  });

  const ownershipByCitizen = [];

  uniqueCitizens.values().forEach((citizen) => {
    let numberOfSharesOwned = selectedBusiness.stockHistory.filter(
      (stockTransfer) => {
        return (
          stockTransfer.citizenID == citizen.citizenID &&
          stockTransfer.bought == true
        );
      },
    ).length;

    let percentageOfOwnership = (
      (numberOfSharesOwned / totalSharesOwned) *
      100
    ).toFixed(2);

    ownershipByCitizen.push({
      ...citizen,
      numberOfSharesOwned,
      percentageOfOwnership,
    });
  });

  function getSharesOwned(business) {
    return business.stockHistory.filter((stockTransfer) => {
      return stockTransfer.bought == true;
    }).length;
  }

  console.log('tot', totalSharesOwned);

  return (
    <div>
      {userIsOwner && (
        <div className='grid grid-cols-5 gap-5'>
          <div className='col-span-5 lg:col-span-1 lg:h-40 lg:sticky lg:top-6'>
            {navigationSections.map((navigationSection) => {
              const Icon = navigationSection.icon;
              return (
                <div className='flex-auto lg:flex-none'>
                  <button
                    onClick={() => {
                      setSelectedSection(navigationSection.sectionName);
                    }}
                    className={classNames(
                      navigationSection.sectionSelected
                        ? 'bg-sky-500 shadow'
                        : 'hover:bg-gray-800',
                      'rounded p-2 w-full text-center lg:text-left',
                    )}
                  >
                    <div className='flex gap-2 justify-center lg:justify-start'>
                      <Icon className='h-6 w-6' fill='white' />
                      <p
                        className={classNames(
                          navigationSection.sectionSelected
                            ? 'text-white'
                            : 'text-gray-200',
                          'font-semibold',
                        )}
                      >
                        {navigationSection.sectionName}
                      </p>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
          <div className='col-span-5 lg:col-span-4 bg-gray-800 rounded'>
            <a
              className='rounded-full px-3 py-2 bg-sky-400 w-56 m-2 font-semibold hover:bg-sky-500 flex justify-center shadow'
              href='/businesses'
            >
              <ArrowCircleLeftIcon className='h-6 w-6' />
              Back to Businesses
            </a>
            {selectedSection == 'Items' && (
              <div>
                <Popup
                  header='Edit Product'
                  additionalComponent={() => {
                    return <EditProductPopupBody />;
                  }}
                  open={editItemPopupOpen}
                  setOpen={setEditItemPopupOpen}
                />
                <div className='gap-y-2 border-b border-gray-500'>
                  <div className='gap-y-2 py-2'>
                    <div className='bg-black border-2 border-gray-700 p-4 m-2 shadow'>
                      <p className='text-center text-3xl font-bold'>
                        {selectedBusiness.name}
                      </p>
                      <p className='text-center text-lg'>
                        {selectedBusiness.description}
                      </p>
                    </div>
                  </div>
                </div>
                <div className='flow-root px-2'>
                  <div className='float-left py-2'>
                    <button
                      className='bg-sky-400 hover:bg-sky-500 font-semibold rounded-full px-3 py-2 shadow flex'
                      onClick={() => {
                        setAddItemPopupOpen(true);
                      }}
                    >
                      <PlusCircleIcon className='w-6 h-6' />
                      Add Item
                    </button>
                    <Popup
                      header='New Product'
                      additionalComponent={() => {
                        return <AddItemPopupBody />;
                      }}
                      open={addItemPopupOpen}
                      setOpen={setAddItemPopupOpen}
                    />
                    <div className='flex align-middle h-full'>
                      <Popup
                        header='Successful'
                        additionalComponent={() => {
                          return (
                            <PurchaseSuccessfulPopupBody
                              setPurchaseSuccessfulPopupOpen={
                                setPurchaseSuccessfulPopupBodyOpen
                              }
                              //purchaseDescription={`Purchase of ${quantity} of ${product}`}
                            />
                          );
                        }}
                        showCloseButton={false}
                        open={purchaseSuccessfulPopupBodyOpen}
                        setOpen={setPurchaseSuccessfulPopupBodyOpen}
                      />
                    </div>
                  </div>
                  <div className='float-right'>
                    <p className='font-bold text-center'>Personal Balance</p>
                    <p className='text-center border border-gray-400 shadow font-semibold bg-gray-900'>
                      W{user.westers}
                    </p>
                  </div>
                  <input
                    className='rounded w-full border-2 border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-700 focus:border-gray-700 p-2 mt-8 mb-3'
                    placeholder='Search products...'
                    onChange={(event) => {
                      setSearchInput(event.target.value);
                    }}
                  ></input>
                </div>
                <div className=''>
                  {selectedBusiness.products != undefined && (
                    <div className='lg:grid lg:grid-cols-4 gap-2 m-2'>
                      {Object.values(selectedBusiness.products)
                        .sort((product1, product2) => {
                          return product1.name.localeCompare(product2.name);
                        })
                        .filter((product) => {
                          if (searchInput != '') {
                            return product.name
                              .toUpperCase()
                              .includes(searchInput.toUpperCase());
                          } else {
                            return true;
                          }
                        })
                        .map((product) => {
                          return (
                            <div className='pt-2'>
                              <Product product={product} />
                            </div>
                          );
                        })}
                    </div>
                  )}
                  {selectedBusiness.products == undefined && (
                    <p className='font-semibold text-center text-gray-200 pt-3 pb-6'>
                      NO PRODUCTS YET
                    </p>
                  )}
                </div>
              </div>
            )}
            {selectedSection == 'Bank Account' && (
              <div className='mx-1 lg:mx-2 my-1 lg:my-2'>
                <div className='flow-root p-2'>
                  <div className='float-left'>
                    <p className='text-3xl text-white font-bold'>Bank</p>
                  </div>

                  <div className='float-right flex-wrap flex align-middle gap-4'>
                    <div className='md:w-96 w-full text-white justify-center flex flex-col'>
                      <i className='text-left font-semibold'>
                        Pays 10% of what's in this account out to shareholders
                        according to their % ownership...
                      </i>
                      {ownershipByCitizen.length > 0 ? (
                        <div className='bg-black p-2 border-1 border-gray-600'>
                          {ownershipByCitizen.map((ownByCit) => {
                            console.log('hm?', ownByCit);
                            return (
                              <p className='font-semibold'>
                                {ownByCit.citizenName} (
                                {censor(ownByCit.citizenID)}):{' '}
                                {ownByCit.numberOfSharesOwned} shares (
                                {ownByCit.percentageOfOwnership}%)
                              </p>
                            );
                          })}
                        </div>
                      ) : null}

                      <button
                        className={
                          (ownershipByCitizen.length > 0 &&
                          selectedBusiness.westers > 0
                            ? 'bg-sky-400 hover:bg-sky-500 text-black'
                            : 'bg-sky-200 text-gray-500') +
                          ' rounded-b-lg px-3 py-2 align-middle justify-center font-semibold flex shadow'
                        }
                        onClick={() => {
                          if (
                            ownershipByCitizen.length > 0 &&
                            selectedBusiness.westers > 0
                          ) {
                            database
                              .ref(
                                `/businesses/${selectedBusiness.businessID}/westers`,
                              )
                              .get()
                              .then((businessWestersSnapshot) => {
                                if (businessWestersSnapshot.val()) {
                                  const totalSharesOwned =
                                    selectedBusiness.stockHistory.filter(
                                      (stockTransfer) => {
                                        return (
                                          stockTransfer.bought == true &&
                                          stockTransfer.citizenID != 'SYSTEM'
                                        );
                                      },
                                    ).length;

                                  let uniqueCitizenIDs = new Set();

                                  selectedBusiness.stockHistory.forEach(
                                    (stockTransfer) => {
                                      if (stockTransfer.citizenID != 'SYSTEM')
                                        uniqueCitizenIDs.add(
                                          stockTransfer.citizenID,
                                        );
                                    },
                                  );

                                  let businessWestersLeft =
                                    businessWestersSnapshot.val();

                                  uniqueCitizenIDs.forEach((citizenID) => {
                                    let numberOfSharesOwned =
                                      selectedBusiness.stockHistory.filter(
                                        (stockTransfer) => {
                                          return (
                                            stockTransfer.citizenID ==
                                              citizenID &&
                                            stockTransfer.bought == true
                                          );
                                        },
                                      ).length;

                                    let percentageOfOwnership =
                                      numberOfSharesOwned / totalSharesOwned;

                                    let dividendsPayout = Number(
                                      (
                                        businessWestersSnapshot.val() *
                                        percentageOfOwnership *
                                        0.1
                                      ).toFixed(2),
                                    );

                                    database
                                      .ref(`/citizens/${citizenID}`)
                                      .get()
                                      .then((citizenSnapshot) => {
                                        let citizenRecipient =
                                          citizenSnapshot.val();

                                        let receiverResultingBalance = Number(
                                          (
                                            Number(citizenRecipient.westers) +
                                            Number(dividendsPayout)
                                          ).toFixed(2),
                                        );
                                        database
                                          .ref(`/citizens/${citizenID}/westers`)
                                          .set(receiverResultingBalance);

                                        let senderResultingBalance = Number(
                                          (
                                            Number(businessWestersLeft) -
                                            Number(dividendsPayout)
                                          ).toFixed(2),
                                        );
                                        businessWestersLeft =
                                          senderResultingBalance;

                                        database
                                          .ref(
                                            `/businesses/${selectedBusiness.businessID}/westers`,
                                          )
                                          .set(senderResultingBalance);
                                        selectedBusiness.westers =
                                          senderResultingBalance;

                                        //updateStockPrice();
                                        if (
                                          dividendsPayout > 0 &&
                                          numberOfSharesOwned > 0
                                        ) {
                                          const transferID = generateID('MT');
                                          database
                                            .ref(
                                              `/businesses/${selectedBusiness.businessID}/transfers/${transferID}`,
                                            )
                                            .set({
                                              transferID: transferID,
                                              date: `${getDate()}, ${getYear()}`,
                                              time: getTime(),
                                              mssce: Math.round(
                                                new Date().getTime() -
                                                  charlingtonEpoch,
                                              ),
                                              amount: dividendsPayout,
                                              receiverID: citizenID,
                                              receiverName:
                                                citizenRecipient.name,
                                              type: 'Outgoing',
                                              reason: `Dividends (10% of business account) for ${numberOfSharesOwned} shares owned (${(
                                                percentageOfOwnership * 100
                                              ).toFixed(2)}%) in ${
                                                selectedBusiness.name
                                              } (${
                                                selectedBusiness.businessID
                                              })`,
                                              resultingBalance:
                                                senderResultingBalance,
                                            });
                                          database
                                            .ref(
                                              `/citizens/${citizenID}/transfers/${transferID}`,
                                            )
                                            .set({
                                              transferID: transferID,
                                              date: `${getDate()}, ${getYear()}`,
                                              time: getTime(),
                                              mssce: Math.round(
                                                new Date().getTime() -
                                                  charlingtonEpoch,
                                              ),
                                              amount: dividendsPayout,
                                              senderID:
                                                selectedBusiness.businessID,
                                              senderName: selectedBusiness.name,
                                              type: 'Incoming',
                                              reason: `Dividends (10% of business account) for ${numberOfSharesOwned} shares owned (${(
                                                percentageOfOwnership * 100
                                              ).toFixed(2)}%) in ${
                                                selectedBusiness.name
                                              } (${
                                                selectedBusiness.businessID
                                              })`,
                                              resultingBalance:
                                                receiverResultingBalance,
                                            });
                                        }

                                        updateBusiness();
                                        localStorage.setItem(
                                          'selectedBusiness',
                                          JSON.stringify(selectedBusiness),
                                        );
                                        /* database.ref(`/citizens/${user["Citizen ID"]}/ArrayTest`).set(
                                                  ['igrn', 'griolw', 'gej', 'aqe']
                                              ); */
                                      });
                                  });
                                }
                              });
                          }
                        }}
                      >
                        <ArrowCircleUpIcon
                          className={
                            (ownershipByCitizen.length > 0 &&
                            selectedBusiness.westers > 0
                              ? 'text-black'
                              : 'text-gray-500') + ' w-6 h-6'
                          }
                        />
                        <p
                          className={
                            (ownershipByCitizen.length > 0 &&
                            selectedBusiness.westers > 0
                              ? 'text-black'
                              : 'text-gray-500') + ' pl-1'
                          }
                        >
                          Pay Dividends to Shareholders
                        </p>
                      </button>
                    </div>
                    <div className='w-full md:w-auto flex flex-col justify-end'>
                      <button
                        className='justify-center rounded-full px-3 py-2 bg-sky-400 font-semibold hover:bg-sky-500 flex shadow'
                        onClick={() => {
                          setNewTransferPopupOpen(true);
                        }}
                      >
                        <PlusCircleIcon className='w-6 h-6' />
                        <p className='pl-1 text-black'>Send Money</p>
                      </button>
                    </div>

                    <Popup
                      open={newTransferPopupOpen}
                      setOpen={setNewTransferPopupOpen}
                      header='New Transfer'
                      onClickSave={() => {}}
                      inputs={[]}
                      saveText={'Send'}
                      additionalComponent={() => {
                        return (
                          <NewBusinessTransferPopupBody
                            database={database}
                            user={user}
                            business={selectedBusiness}
                            updateBusiness={updateBusiness}
                            setUser={setUser}
                            getTime={getTime}
                            getDate={getDate}
                            getYear={getYear}
                            setNewBusinessTransferPopupOpen={
                              setNewTransferPopupOpen
                            }
                          />
                        );
                      }}
                    />
                  </div>
                </div>
                <div className='p-2 group bg-gray-800 rounded'>
                  <div className='lg:flow-root w-full  p-1 shadow bg-gray-900 border-4 border-gray-500 text-bottom'>
                    <div className='lg:float-left text-bottom'>
                      <p className='text-2xl font-semibold pl-1 text-white'>
                        Current Balance
                      </p>
                    </div>
                    <div className='flex justify-center text-2xl font-bold lg:float-right px-1 border-2 border-gray-500 bg-gray-800'>
                      <p className=''>W{selectedBusiness.westers}</p>
                    </div>
                  </div>

                  <div className='w-full border-gray-500 border-b-4 border-r-4 border-l-4 bg-gray-700'>
                    <p className='font-semibold text-white px-2 pt-2 text-2xl'>
                      Transaction History
                    </p>
                    {selectedBusiness.transfers != undefined &&
                    Object.values(selectedBusiness.transfers).length != 0 ? (
                      <div className='lg:p-2 p-1 bg-gray-800'>
                        {Object.values(selectedBusiness.transfers)
                          .sort((transfer1, transfer2) => {
                            return transfer2.mssce - transfer1.mssce;
                          })
                          .map((transfer) => {
                            return (
                              <div className='p-1'>
                                <Transfer transfer={transfer} />
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      <div className='p-2 bg-gray-800'>
                        <p className='font-semibold text-2xl'>Nothing yet</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {selectedSection == 'Orders' && (
              <div className='m-4'>
                <div className=''>
                  <p className='text-3xl text-white font-bold'>Orders</p>
                </div>
                {selectedBusiness.orders != undefined ? (
                  <div>
                    {Object.values(selectedBusiness.orders)
                      .sort((order1, order2) => {
                        return order2.mssce - order1.mssce;
                      })
                      .map((order) => {
                        return (
                          <div className='py-2'>
                            <Order order={order} />
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <p className='text-center text-gray-400 py-4 font-semibold'>
                    NONE YET
                  </p>
                )}
              </div>
            )}
            {selectedSection == 'Manage' && (
              <div>
                <div className='p-4'>
                  <p className='text-3xl text-white font-bold'>Manage</p>
                </div>
                <div className='py-4 rounded bg-gray-900 mx-4 my-2 shadow'>
                  <p className='font-bold text-sm text-center'>ADD OWNER</p>
                  <CitizenUserDropboxMenu
                    citizens={citizens}
                    filteredCitizens={filteredCitizens}
                    setFilteredCitizens={setFilteredCitizens}
                    user={user}
                    selectedCitizen={selectedCitizen}
                    setSelectedCitizen={setSelectedCitizen}
                  />
                  <div className='flex justify-center pt-2'>
                    <button
                      className={classNames(
                        selectedCitizen != undefined
                          ? 'bg-sky-400 hover:bg-sky-500'
                          : 'bg-sky-300 text-gray-400',
                        'font-semibold rounded-full px-3 py-2 shadow flex',
                      )}
                      onClick={() => {
                        const ownersList = Object.values(
                          selectedBusiness.owners,
                        );
                        ownersList.push({
                          citizenID: selectedCitizen.citizenID,
                          name: selectedCitizen.name,
                        });
                        database
                          .ref(
                            `/businesses/${selectedBusiness.businessID}/owners`,
                          )
                          .set(ownersList);
                        updateBusiness();
                      }}
                    >
                      <PlusCircleIcon className='h-6 w-6' />
                      Add
                    </button>
                  </div>
                </div>
                <div className='p-4'>
                  {Object.values(selectedBusiness.owners).map((owner) => {
                    return (
                      <div className='py-2'>
                        <div className='bg-gray-900 border border-gray-400 shadow p-4'>
                          <div className='flow-root'>
                            <p className='float-left font-bold text-lg'>
                              {owner.name}
                            </p>
                            <p className='float-right text-lg'>
                              {censor(owner.citizenID)}
                            </p>
                          </div>
                          {owner.citizenID != user.citizenID && (
                            <div className='flex justify-center'>
                              <button
                                className='bg-sky-400 hover:bg-sky-500 rounded-full px-3 py-2 shadow flex font-semibold'
                                onClick={() => {
                                  const ownersList = Object.values(
                                    selectedBusiness.owners,
                                  );
                                  ownersList.splice(
                                    ownersList.indexOf(owner),
                                    1,
                                  );
                                  database
                                    .ref(
                                      `/businesses/${selectedBusiness.businessID}/owners`,
                                    )
                                    .set(ownersList);
                                  updateBusiness();
                                }}
                              >
                                <XCircleIcon className='w-6 h-6' />
                                Remove Owner
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className='py-4 border-t border-gray-500'>
                  <div className='p-4'>
                    <input
                      className='w-full rounded border-2 border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-700 focus:border-gray-700 p-2'
                      defaultValue={selectedBusiness.name}
                      placeholder='Business name'
                      onChange={(event) => {
                        setNewBusinessName(event.target.value);
                      }}
                    ></input>
                  </div>
                  <div className='p-4'>
                    <textarea
                      className='w-full resize-none rounded border-2 border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-700 focus:border-gray-700 p-2'
                      defaultValue={selectedBusiness.description}
                      placeholder='Business description'
                      onChange={(event) => {
                        setNewBusinessDescription(event.target.value);
                      }}
                    ></textarea>
                  </div>
                  {(newBusinessName != selectedBusiness.name ||
                    newBusinessDescription != selectedBusiness.description) &&
                    newBusinessName &&
                    newBusinessDescription && (
                      <div className='flex justify-center'>
                        <button
                          className='bg-sky-400 hover:bg-sky-500 rounded-full px-3 py-2 shadow flex font-semibold'
                          onClick={() => {
                            database
                              .ref(
                                `/businesses/${selectedBusiness.businessID}/name`,
                              )
                              .set(newBusinessName);
                            database
                              .ref(
                                `/businesses/${selectedBusiness.businessID}/description`,
                              )
                              .set(newBusinessDescription);
                            updateBusiness();
                          }}
                        >
                          <CheckCircleIcon className='h-6 w-6' />
                          Update Name and Description
                        </button>
                      </div>
                    )}
                </div>
                <br />
                <div className='flex justify-center py-4 border-t border-gray-500'>
                  <button
                    className='bg-red-500 hover:bg-red-600 rounded-full px-3 py-2 shadow flex font-semibold'
                    onClick={() => {
                      database
                        .ref(`/businesses/${selectedBusiness.businessID}`)
                        .set(null);
                      window.location.href = '/businesses';
                    }}
                  >
                    <XCircleIcon className='w-6 h-6' />
                    Delete Business
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {!userIsOwner && (
        <div className='bg-gray-800 rounded p-2'>
          <a
            className='rounded-full px-3 py-2 bg-sky-400 w-56 font-semibold hover:bg-sky-500 flex justify-center shadow'
            href='/businesses'
          >
            <ArrowCircleLeftIcon className='h-6 w-6' />
            Back to Businesses
          </a>
          <div className='gap-y-2 py-6 border-b border-gray-500'>
            <div className='bg-black border-2 border-gray-700 p-4 shadow'>
              <p className='text-center text-3xl font-bold'>
                {selectedBusiness.name}
              </p>
              <p className='text-center text-lg'>
                {selectedBusiness.description}
              </p>
            </div>
          </div>
          <div className='flex align-middle h-full'>
            <Popup
              header='Successful'
              additionalComponent={() => {
                return (
                  <PurchaseSuccessfulPopupBody
                    setPurchaseSuccessfulPopupOpen={
                      setPurchaseSuccessfulPopupBodyOpen
                    }
                    //purchaseDescription={`Purchase of ${quantity} of ${product}`}
                  />
                );
              }}
              showCloseButton={false}
              open={purchaseSuccessfulPopupBodyOpen}
              setOpen={setPurchaseSuccessfulPopupBodyOpen}
            />
          </div>
          <div className='flow-root px-2'>
            <div className='float-right'>
              <p className='font-bold text-center'>Personal Balance</p>
              <p className='text-center border border-gray-400 shadow font-semibold bg-black'>
                W{user.westers}
              </p>
            </div>
            <input
              className='rounded w-full border-2 border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-700 focus:border-gray-700 p-2 mt-8 mb-3'
              placeholder='Search products...'
              onChange={(event) => {
                setSearchInput(event.target.value);
              }}
            ></input>
          </div>
          <div className=''>
            {selectedBusiness.products != undefined && (
              <div className='lg:grid lg:grid-cols-4 gap-2 lg:m-2 m-1'>
                {Object.values(selectedBusiness.products)
                  .sort((product1, product2) => {
                    return product1.name.localeCompare(product2.name);
                  })
                  .filter((product) => {
                    if (searchInput != '') {
                      return product.name
                        .toUpperCase()
                        .includes(searchInput.toUpperCase());
                    } else {
                      return true;
                    }
                  })
                  .map((product) => {
                    return (
                      <div className='pt-2'>
                        <Product product={product} />
                      </div>
                    );
                  })}
              </div>
            )}
            {selectedBusiness.products == undefined && (
              <p className='font-semibold text-center text-gray-400 pt-3 pb-6'>
                NO PRODUCTS YET
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );

  function Product({ product }) {
    const [quantity, setQuantity] = useState(1);
    return (
      <div className='bg-black shadow border border-gray-400 place-content-end'>
        <p className='text-center font-bold p-2 text-xl'>{product.name}</p>
        <p className='text-sm font-bold text-center text-gray-300'>NUMBER</p>
        <div className='px-4 pb-2'>
          <input
            type='Number'
            defaultValue={1}
            min={1}
            onChange={(event) => {
              if (event.target.value > 0) {
                setQuantity(event.target.value);
              }
            }}
            className='border-2 rounded border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-700 focus:border-gray-700 w-full p-1'
          ></input>
        </div>
        <div className='flex'>
          {product.buyable && (
            <div
              className={classNames(
                product.orderable ? 'pr-1' : 'pr-2',
                'pl-2 py-2 flex-1',
              )}
            >
              <button
                className={classNames(
                  product.buyingPrice * quantity <= user.westers
                    ? 'bg-sky-400 hover:bg-sky-500'
                    : 'bg-sky-200 text-gray-400',
                  'w-full shadow rounded-full px-3 py-2 font-semibold',
                )}
                onClick={() => {
                  var businemsscesultingBalance = 0;
                  var senderResultingBalance = 0;
                  if (product.buyingPrice * quantity <= user.westers) {
                    const transferAmount = Number(
                      quantity * product.buyingPrice,
                    );
                    database
                      .ref(`/businesses/${selectedBusiness.businessID}/westers`)
                      .get()
                      .then((westersSnapshot) => {
                        const amountTaxed = Math.round(
                          Number(transferAmount) * salesTaxRate,
                        );
                        businemsscesultingBalance = Number(
                          (
                            Number(westersSnapshot.val()) +
                            transferAmount -
                            amountTaxed
                          ).toFixed(2),
                        );
                        database
                          .ref(
                            `/businesses/${selectedBusiness.businessID}/westers`,
                          )
                          .set(businemsscesultingBalance);
                        database
                          .ref(`/citizens/${user.citizenID}/westers`)
                          .get()
                          .then((westersSnapshot) => {
                            senderResultingBalance = Number(
                              (
                                Number(westersSnapshot.val()) - transferAmount
                              ).toFixed(2),
                            );
                            database
                              .ref(`/citizens/${user.citizenID}/westers`)
                              .set(senderResultingBalance);
                            user.westers = senderResultingBalance;
                            const transferID = generateID('MT');
                            database
                              .ref(
                                `/citizens/${user.citizenID}/transfers/${transferID}`,
                              )
                              .set({
                                transferID: transferID,
                                date: `${getDate()}, ${getYear()}`,
                                time: getTime(),
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                                amount: transferAmount,
                                receiverID: selectedBusiness.businessID,
                                receiverName: selectedBusiness.name,
                                type: 'Outgoing',
                                reason: `Bought ${quantity} of '${product.name}'`,
                                resultingBalance: senderResultingBalance,
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                              });
                            database
                              .ref(
                                `/businesses/${selectedBusiness.businessID}/transfers/${transferID}`,
                              )
                              .set({
                                transferID: transferID,
                                date: `${getDate()}, ${getYear()}`,
                                time: getTime(),
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                                amount: transferAmount - amountTaxed,
                                senderID: user.citizenID,
                                senderName: user.name,
                                type: 'Incoming',
                                reason: `Bought ${quantity} of '${product.name}'`,
                                resultingBalance: businemsscesultingBalance,
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                              });
                            const purchaseID = generateID('PU');
                            database
                              .ref(
                                `/citizens/${user.citizenID}/businessPurchases/${purchaseID}`,
                              )
                              .set({
                                purchaseID: purchaseID,
                                type: 'Buy',
                                product: {
                                  name: product.name,
                                  productID: product.productID,
                                  buyingPrice: product.buyingPrice,
                                },
                                business: {
                                  businessID: selectedBusiness.businessID,
                                  name: selectedBusiness.name,
                                  description: selectedBusiness.description,
                                },
                                quantity: quantity,
                                total: transferAmount,
                                timePurchased: getTime(),
                                datePurchased: getDate(),
                                yearPurchased: getYear(),
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                              });
                            if (amountTaxed > 0) {
                              const taxTransferID = generateID('MT');
                              database
                                .ref('/government')
                                .get()
                                .then((governmentSnapshot) => {
                                  var governmentFunds =
                                    governmentSnapshot.val().westers;
                                  const newGovernmentFunds = Number(
                                    (governmentFunds + amountTaxed).toFixed(2),
                                  );
                                  database
                                    .ref('/government/westers')
                                    .set(newGovernmentFunds);
                                  database
                                    .ref(
                                      `/government/transfers/${taxTransferID}`,
                                    )
                                    .set({
                                      transferID: taxTransferID,
                                      date: `${getDate()}, ${getYear()}`,
                                      time: getTime(),
                                      mssce: Math.round(
                                        new Date().getTime() - charlingtonEpoch,
                                      ),
                                      amount: amountTaxed,
                                      senderID: user.citizenID,
                                      senderName: user.name,
                                      type: 'Incoming',
                                      reason: `${
                                        salesTaxRate * 100
                                      }% tax of ${transferID}`,
                                      resultingBalance: newGovernmentFunds,
                                    });
                                });
                            }
                            setPurchaseSuccessfulPopupBodyOpen(true);
                            setTimeout(() => {
                              setPurchaseSuccessfulPopupBodyOpen(false);
                            }, 3000);

                            setUser(user);
                            localStorage.setItem('user', JSON.stringify(user));
                            updateBusiness();
                          });
                      });
                  }
                }}
              >
                <div className='flex justify-center'>Buy</div>
                <p className='text-black'>W{quantity * product.buyingPrice}</p>
              </button>
            </div>
          )}
          {product.orderable && (
            <div
              className={classNames(
                product.orderable && product.buyable ? 'pl-1' : 'pl-2',
                'pr-2 py-2 flex-1',
              )}
            >
              <button
                className={classNames(
                  product.orderingPrice * quantity <= user.westers
                    ? 'bg-sky-400 hover:bg-sky-500'
                    : 'bg-sky-200 text-gray-500',
                  'w-full shadow rounded-full px-3 py-2 font-semibold',
                )}
                onClick={() => {
                  var businemsscesultingBalance = 0;
                  var senderResultingBalance = 0;
                  if (product.orderingPrice * quantity <= user.westers) {
                    const transferAmount = Number(
                      (quantity * product.orderingPrice).toFixed(2),
                    );
                    database
                      .ref(`/businesses/${selectedBusiness.businessID}/westers`)
                      .get()
                      .then((westersSnapshot) => {
                        const amountTaxed = Math.round(
                          Number(transferAmount) * salesTaxRate,
                        );
                        businemsscesultingBalance = Number(
                          (
                            Number(westersSnapshot.val()) +
                            transferAmount -
                            amountTaxed
                          ).toFixed(2),
                        );
                        database
                          .ref(
                            `/businesses/${selectedBusiness.businessID}/westers`,
                          )
                          .set(businemsscesultingBalance);
                        database
                          .ref(`/citizens/${user.citizenID}/westers`)
                          .get()
                          .then((westersSnapshot) => {
                            senderResultingBalance = Number(
                              (
                                Number(westersSnapshot.val()) - transferAmount
                              ).toFixed(2),
                            );
                            database
                              .ref(`/citizens/${user.citizenID}/westers`)
                              .set(senderResultingBalance);
                            user.westers = senderResultingBalance;
                            const transferID = generateID('MT');
                            database
                              .ref(
                                `/citizens/${user.citizenID}/transfers/${transferID}`,
                              )
                              .set({
                                transferID: transferID,
                                date: `${getDate()}, ${getYear()}`,
                                time: getTime(),
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                                amount: transferAmount,
                                receiverID: selectedBusiness.businessID,
                                receiverName: selectedBusiness.name,
                                type: 'Outgoing',
                                reason: `Ordered ${quantity} of '${product.name}'`,
                                resultingBalance: senderResultingBalance,
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                              });
                            database
                              .ref(
                                `/businesses/${selectedBusiness.businessID}/transfers/${transferID}`,
                              )
                              .set({
                                transferID: transferID,
                                date: `${getDate()}, ${getYear()}`,
                                time: getTime(),
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                                amount: transferAmount - amountTaxed,
                                senderID: user.citizenID,
                                senderName: user.name,
                                type: 'Incoming',
                                reason: `Ordered ${quantity} of '${product.name}'`,
                                resultingBalance: businemsscesultingBalance,
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                              });
                            const purchaseID = generateID('PU');
                            database
                              .ref(
                                `/citizens/${user.citizenID}/businessPurchases/${purchaseID}`,
                              )
                              .set({
                                purchaseID: purchaseID,
                                type: 'Order',
                                delivered: false,
                                product: {
                                  name: product.name,
                                  productID: product.productID,
                                  orderingPrice: product.orderingPrice,
                                },
                                business: {
                                  businessID: selectedBusiness.businessID,
                                  name: selectedBusiness.name,
                                  description: selectedBusiness.description,
                                },
                                quantity: quantity,
                                total: transferAmount,
                                timePurchased: getTime(),
                                datePurchased: getDate(),
                                yearPurchased: getYear(),
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                              });
                            database
                              .ref(
                                `/businesses/${selectedBusiness.businessID}/orders/${purchaseID}`,
                              )
                              .set({
                                purchaseID: purchaseID,
                                delivered: false,
                                product: {
                                  name: product.name,
                                  productID: product.productID,
                                  orderingPrice: product.orderingPrice,
                                },
                                business: {
                                  businessID: selectedBusiness.businessID,
                                  name: selectedBusiness.name,
                                  description: selectedBusiness.description,
                                },
                                customer: {
                                  citizenID: user.citizenID,
                                  name: user.name,
                                },
                                quantity: quantity,
                                total: transferAmount - amountTaxed,
                                timePurchased: getTime(),
                                datePurchased: getDate(),
                                yearPurchased: getYear(),
                                mssce: Math.round(
                                  new Date().getTime() - charlingtonEpoch,
                                ),
                              });
                            if (amountTaxed > 0) {
                              const taxTransferID = generateID('MT');
                              database
                                .ref('/government')
                                .get()
                                .then((governmentSnapshot) => {
                                  var governmentFunds =
                                    governmentSnapshot.val().westers;
                                  const newGovernmentFunds = Number(
                                    (governmentFunds + amountTaxed).toFixed(2),
                                  );
                                  database
                                    .ref('/government/westers')
                                    .set(newGovernmentFunds);
                                  database
                                    .ref(
                                      `/government/transfers/${taxTransferID}`,
                                    )
                                    .set({
                                      transferID: taxTransferID,
                                      date: `${getDate()}, ${getYear()}`,
                                      time: getTime(),
                                      mssce: Math.round(
                                        new Date().getTime() - charlingtonEpoch,
                                      ),
                                      amount: amountTaxed,
                                      senderID: user.citizenID,
                                      senderName: user.name,
                                      type: 'Incoming',
                                      reason: `${
                                        salesTaxRate * 100
                                      }% tax of ${transferID}`,
                                      resultingBalance: newGovernmentFunds,
                                    });
                                });
                            }
                            setPurchaseSuccessfulPopupBodyOpen(true);
                            setTimeout(() => {
                              setPurchaseSuccessfulPopupBodyOpen(false);
                            }, 3000);

                            setUser(user);
                            localStorage.setItem('user', JSON.stringify(user));
                            updateBusiness();
                          });
                      });
                  }
                }}
              >
                <div className='flex justify-center'>Order</div>
                <p class='text-black'>W{quantity * product.orderingPrice}</p>
              </button>
              {/* <Popup
                header='Successful'
                additionalComponent={() => {
                  return (
                    <PurchaseSuccessfulPopupBody
                      purchaseDescription={`Order of ${quantity} of ${product}`}
                    />
                  );
                }}
                open={purchaseSuccessfulPopupBodyOpen}
                setOpen={setPurchaseSuccessfulPopupBodyOpen}
              /> */}
            </div>
          )}
        </div>
        {userIsOwner && (
          <div className='grid grid-cols-2 p-2 gap-2'>
            <button className='shadow rounded-full px-3 py-2 font-semibold bg-sky-400 hover:bg-sky-500'>
              <div
                className='flex justify-center'
                onClick={() => {
                  setProductBeingEdited(product);
                  setEditItemPopupOpen(true);
                }}
              >
                <PencilAltIcon className='w-6 h-6' />
                Edit
              </div>
            </button>
            <button className='shadow rounded-full px-3 py-2 font-semibold bg-red-500 hover:bg-red-600'>
              <div
                className='flex justify-center'
                onClick={() => {
                  database
                    .ref(
                      `/businesses/${selectedBusiness.businessID}/products/${product.productID}`,
                    )
                    .set(null);
                  updateBusiness();
                }}
              >
                <XCircleIcon className='w-6 h-6' />
                Delete
              </div>
            </button>
          </div>
        )}
      </div>
    );
  }

  function Transfer({ transfer }) {
    return (
      <div className='border border-gray-400 bg-black shadow'>
        <div className='w-full lg:flow-root border-b border-gray-400'>
          <p className='lg:float-left pl-2 py-2 font-semibold text-gray-300'>
            {transfer.date} at {transfer.time}
          </p>
          <p className='lg:float-right lg:pl-0 pl-2 pr-2 py-2 font-semibold text-gray-300'>
            {transfer.transferID} {transfer.mssce}
          </p>
        </div>
        <div className='grid grid-cols-4 lg:gap-3 gap-y-3 p-2'>
          {transfer.type == 'Incoming' ? (
            <div className='col-span-4 lg:col-span-2 grid grid-cols-2'>
              <div className='col-span-1'>
                <p className='font-semibold'>Amount</p>
                <p className='text-green-500'>+W{transfer.amount}</p>
              </div>
              <div className='col-span-1'>
                <p className='font-semibold'>Sender</p>
                <p className=''>{transfer.senderName}</p>
                <p className=''>
                  {transfer.senderName !=
                    'Charlington Establishment and Zard' &&
                  transfer.senderName != 'Charlington National Bank' &&
                  transfer.senderName != 'Stock Market'
                    ? censor(transfer.senderID)
                    : ''}
                </p>
              </div>
            </div>
          ) : (
            <div className='col-span-4 lg:col-span-2 grid grid-cols-2'>
              <div className='col-span-1'>
                <p className='font-semibold'>Amount</p>
                <p className='text-red-500'>-W{transfer.amount}</p>
              </div>
              <div className='col-span-1'>
                <p className='font-semibold'>Receiver</p>
                <p className=''>{transfer.receiverName}</p>
                <p className=''>
                  {transfer.receiverName !=
                    'Charlington Establishment and Zard' &&
                  transfer.receiverName != 'Charlington National Bank' &&
                  transfer.receiverName != 'Stock Market'
                    ? censor(transfer.receiverID)
                    : ''}
                </p>
              </div>
            </div>
          )}
          <div className='col-span-2 lg:col-span-1'>
            <p className='font-semibold'>Reason</p>
            <p className=''>{transfer.reason}</p>
          </div>
          <div className='col-span-2 lg:col-span-1'>
            <p className='font-semibold'>Resulting Balance</p>
            <p className=''>W{transfer.resultingBalance}</p>
          </div>
        </div>
      </div>
    );
  }

  function AddItemPopupBody({}) {
    const [newItemBuyingPrice, setNewItemBuyingPrice] = useState(null);
    const [newItemOrderingPrice, setNewItemOrderingPrice] = useState(null);
    const [newItemName, setNewItemName] = useState('');
    const [newItemBuyable, setNewItemBuyable] = useState(true);
    const [newItemOrderable, setNewItemOrderable] = useState(false);

    function generateProductID() {
      var productID = 'PR-';
      for (var i = 0; i < 5; i++) {
        productID = productID + String(Math.floor(Math.random() * 10));
      }
      return productID;
    }

    function onClickAddItemButton() {
      if (
        newItemName &&
        (newItemBuyable ? newItemBuyingPrice > 0 : true) &&
        (newItemOrderable ? newItemOrderingPrice > 0 : true) &&
        (newItemOrderable || newItemBuyable)
      ) {
        const newProductID = generateProductID();
        database
          .ref(
            `/businesses/${selectedBusiness.businessID}/products/${newProductID}`,
          )
          .set({
            productID: newProductID,
            name: newItemName,
            buyingPrice: newItemBuyingPrice,
            orderingPrice: newItemOrderingPrice,
            buyable: newItemBuyable,
            orderable: newItemOrderable,
          });
        updateBusiness();
        setAddItemPopupOpen(false);
      }
    }
    return (
      <div className='w-full justify-center '>
        <div className='pb-4'>
          <div className='p-5 bg-sky-800 rounded shadow'>
            <div className=''>
              <p className='text-sm font-bold'>PRODUCT NAME</p>
              <input
                className='rounded p-1 w-full border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 focus:outline-none'
                onChange={(event) => {
                  setNewItemName(event.target.value);
                }}
              ></input>
            </div>
            <div className='bg-gray-900 shadow rounded'>
              <div className='mt-4 flow-root'>
                <p className='float-left pt-2 font-bold pl-2'>Buyable</p>
                <Switch
                  className='float-right'
                  checked={newItemBuyable}
                  onChange={() => {
                    if (newItemBuyable) {
                      setNewItemBuyingPrice(null);
                    }
                    setNewItemBuyable(!newItemBuyable);
                  }}
                  color='primary'
                />
              </div>
              <p className='text-center text-gray-400 text-sm font-semibold w-full p-2'>
                With this option selected, people will click buy when they take
                it from your store, and money will just be transferred
              </p>
              {newItemBuyable && (
                <div className='px-4 pb-4 pt-1'>
                  <p className='text-sm font-bold'>BUYING PRICE</p>
                  <div className='flex w-full justify-center'>
                    <p className='font-semibold pr-1 text-xl'>W</p>
                    <input
                      type='Number'
                      placeholder=''
                      min={0}
                      onChange={(event) => {
                        setNewItemBuyingPrice(event.target.value);
                      }}
                      className='rounded appearance-textfield flex justify-center w-full focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-1'
                    ></input>
                  </div>
                </div>
              )}
            </div>
            <div className='bg-gray-900 shadow rounded'>
              <div className='mt-4 flow-root'>
                <p className='float-left pt-2 font-bold pl-2'>Orderable</p>
                <Switch
                  className='float-right'
                  checked={newItemOrderable}
                  onChange={() => {
                    if (newItemOrderable) {
                      setNewItemOrderingPrice(null);
                    }
                    setNewItemOrderable(!newItemOrderable);
                  }}
                  color='primary'
                />
              </div>
              <p className='text-center text-gray-400 text-sm font-semibold w-full p-2'>
                With this option selected, people will click order, money will
                be transferred, and the order will be added to an order queue
                that your business is expected to fulfill
              </p>
              {newItemOrderable && (
                <div className='px-4 pb-4 pt-1'>
                  <p className='text-sm font-bold'>ORDERING PRICE</p>
                  <div className='flex w-full justify-center'>
                    <p className='font-semibold pr-1 text-xl'>W</p>
                    <input
                      type='Number'
                      placeholder=''
                      min={0}
                      onChange={(event) => {
                        setNewItemOrderingPrice(event.target.value);
                      }}
                      className='rounded appearance-textfield flex justify-center w-full focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-1'
                    ></input>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='flex justify-center'>
          <button
            className={classNames(
              newItemName &&
                (newItemBuyable ? newItemBuyingPrice > 0 : true) &&
                (newItemOrderable ? newItemOrderingPrice > 0 : true) &&
                (newItemOrderable || newItemBuyable)
                ? 'text-black bg-sky-400 hover:bg-sky-500'
                : 'text-gray-400 bg-sky-100',
              'rounded-full px-3 py-2 font-semibold flex shadow',
            )}
            onClick={onClickAddItemButton}
          >
            <PlusCircleIcon className='w-6 h-6' />
            Add
          </button>
        </div>
      </div>
    );
  }

  function EditProductPopupBody({}) {
    const [itemBuyingPrice, setItemBuyingPrice] = useState(
      productBeingEdited.buyingPrice ? productBeingEdited.buyingPrice : null,
    );
    const [itemOrderingPrice, setItemOrderingPrice] = useState(
      productBeingEdited.orderingPrice
        ? productBeingEdited.orderingPrice
        : null,
    );
    const [itemName, setItemName] = useState(productBeingEdited.name);
    const [itemBuyable, setItemBuyable] = useState(
      productBeingEdited.buyable ? true : null,
    );
    const [itemOrderable, setItemOrderable] = useState(
      productBeingEdited.orderable ? true : null,
    );

    function onClickSaveItemButton() {
      if (
        itemName &&
        (itemBuyable ? itemBuyingPrice > 0 : true) &&
        (itemOrderable ? itemOrderingPrice > 0 : true) &&
        (itemOrderable || itemBuyable)
      ) {
        database
          .ref(
            `/businesses/${selectedBusiness.businessID}/products/${productBeingEdited.productID}`,
          )
          .set({
            productID: productBeingEdited.productID,
            name: itemName,
            buyingPrice: itemBuyingPrice,
            orderingPrice: itemOrderingPrice,
            buyable: itemBuyable,
            orderable: itemOrderable,
          });
        updateBusiness();
        setEditItemPopupOpen(false);
      }
    }
    return (
      <div className='w-full justify-center '>
        <div className='pb-4'>
          <div className='p-5 bg-sky-800 rounded shadow'>
            <div className=''>
              <p className='text-sm font-bold text-white'>PRODUCT NAME</p>
              <input
                className='rounded p-1 w-full border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 focus:outline-none'
                value={itemName}
                onChange={(event) => {
                  setItemName(event.target.value);
                }}
              ></input>
            </div>
            <div className='bg-gray-900 shadow rounded'>
              <div className='mt-4 flow-root'>
                <p className='float-left pt-2 font-bold pl-2'>Buyable</p>
                <Switch
                  className='float-right'
                  checked={itemBuyable}
                  onChange={() => {
                    if (itemBuyable) {
                      setItemBuyingPrice(null);
                    }
                    setItemBuyable(!itemBuyable);
                  }}
                  color='primary'
                />
              </div>
              <p className='text-center text-gray-400 text-sm font-semibold w-full p-2'>
                With this option selected, people will click buy when they take
                it from your store, and money will just be transferred
              </p>
              {itemBuyable && (
                <div className='px-4 pb-4 pt-1'>
                  <p className='text-sm font-bold'>BUYING PRICE</p>
                  <div className='flex w-full justify-center'>
                    <p className='font-semibold pr-1 text-xl'>W</p>
                    <input
                      type='Number'
                      placeholder=''
                      defaultValue={itemBuyingPrice}
                      min={0}
                      onChange={(event) => {
                        setItemBuyingPrice(event.target.value);
                      }}
                      className='rounded appearance-textfield flex justify-center w-full focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-1'
                    ></input>
                  </div>
                </div>
              )}
            </div>
            <div className='bg-gray-900 shadow rounded'>
              <div className='mt-4 flow-root'>
                <p className='float-left pt-2 font-bold pl-2'>Orderable</p>
                <Switch
                  className='float-right'
                  checked={itemOrderable}
                  onChange={() => {
                    if (itemOrderable) {
                      setItemOrderingPrice(null);
                    }
                    setItemOrderable(!itemOrderable);
                  }}
                  color='primary'
                />
              </div>
              <p className='text-center text-gray-400 text-sm font-semibold w-full p-2'>
                With this option selected, people will click order, money will
                be transferred, and the order will be added to an order queue
                that your business is expected to fulfill
              </p>
              {itemOrderable && (
                <div className='px-4 pb-4 pt-1'>
                  <p className='text-sm font-bold'>ORDERING PRICE</p>
                  <div className='flex w-full justify-center'>
                    <p className='font-semibold pr-1 text-xl'>W</p>
                    <input
                      type='Number'
                      placeholder=''
                      defaultValue={itemOrderingPrice}
                      min={0}
                      onChange={(event) => {
                        setItemOrderingPrice(event.target.value);
                      }}
                      className='rounded appearance-textfield flex justify-center w-full focus:outline-none border-2 border-gray-500 focus:border-gray-700 focus:ring-1 focus:ring-gray-700 p-1'
                    ></input>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='flex justify-center'>
          <button
            className={classNames(
              itemName &&
                (itemBuyable ? itemBuyingPrice > 0 : true) &&
                (itemOrderable ? itemOrderingPrice > 0 : true) &&
                (itemOrderable || itemBuyable)
                ? 'text-black bg-sky-400 hover:bg-sky-500'
                : 'text-gray-400 bg-sky-100',
              'rounded-full px-3 py-2 font-semibold flex shadow',
            )}
            onClick={onClickSaveItemButton}
          >
            <CheckCircleIcon className='w-6 h-6' />
            Save
          </button>
        </div>
      </div>
    );
  }

  function Order({ order }) {
    return (
      <div className='bg-black border border-gray-400 shadow'>
        <div className='bg-gray-800 border-b border-gray-400 rounded-t p-2 lg:grid-cols-none lg:flow-root grid grid-cols-2 gap-2'>
          <div className='lg:float-left'>
            <p className='text-gray-400 text-sm'>ORDERED</p>
            <p className='text-lg text-white font-semibold'>
              {order.datePurchased}, {order.yearPurchased}
            </p>
          </div>
          <div className='lg:float-left lg:pl-4'>
            <p className='text-gray-400 text-sm'>TOTAL</p>
            <p className='text-lg text-white font-semibold'>W{order.total}</p>
          </div>
          <div className='lg:float-left lg:pl-4'>
            <p className='text-gray-400 text-sm'>CUSTOMER</p>
            <p className='text-lg text-white font-semibold'>
              {order.customer.name}
            </p>
          </div>
          <div className='lg:float-right'>
            <p className='text-gray-400 text-sm'>PURCHASE ID</p>
            <p className='text-lg text-white font-semibold lg:text-right'>
              {order.purchaseID}
            </p>
          </div>
        </div>
        <div className='p-2'>
          <p className='text-2xl font-semibold'>
            {order.product.name} ({order.quantity})
          </p>
          <p className='text-sky-500 text-lg uppercase font-semibold'>
            W{order.product.orderingPrice} each
          </p>
        </div>
        <div className='p-2 border-t border-gray-400'>
          {order.delivered ? (
            <p className='text-green-500 font-semibold text-lg'>
              Delivered {order.dateDelivered}, {order.yearDelivered} at{' '}
              {order.timeDelivered}
            </p>
          ) : (
            <div>
              <p className='font-semibold text-red-500 text-lg'>
                Not delivered
              </p>
              <div className='flex justify-center'>
                <button
                  className='shadow flex rounded-full px-3 py-2 font-semibold bg-sky-400 hover:bg-sky-500'
                  onClick={() => {
                    const businessOrderReference = `/businesses/${selectedBusiness.businessID}/orders/${order.purchaseID}`;
                    database
                      .ref(`${businessOrderReference}/delivered`)
                      .set(true);
                    database
                      .ref(`${businessOrderReference}/timeDelivered`)
                      .set(getTime());
                    database
                      .ref(`${businessOrderReference}/dateDelivered`)
                      .set(getDate());
                    database
                      .ref(`${businessOrderReference}/yearDelivered`)
                      .set(getYear());
                    updateBusiness();

                    const citizenPurchaseReference = `/citizens/${order.customer.citizenID}/businessPurchases/${order.purchaseID}`;
                    database
                      .ref(`${citizenPurchaseReference}/delivered`)
                      .set(true);
                    database
                      .ref(`${citizenPurchaseReference}/timeDelivered`)
                      .set(getTime());
                    database
                      .ref(`${citizenPurchaseReference}/dateDelivered`)
                      .set(getDate());
                    database
                      .ref(`${citizenPurchaseReference}/yearDelivered`)
                      .set(getYear());
                    if (order.customer.citizenID == user.citizenID) {
                      database
                        .ref(`/citizens/${order.customer.citizenID}`)
                        .get()
                        .then((citizen) => {
                          setUser(citizen.val());
                          localStorage.setItem(
                            'user',
                            JSON.stringify(citizen.val()),
                          );
                        });
                    }
                  }}
                >
                  <CheckCircleIcon className='h-6 w-6' />
                  Set as Delivered
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
};

export default Business;
